import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

type ToastProps = ReturnType<typeof useToast>;

export const handleFileUpload = async (
  file: File, 
  toast: Pick<ToastProps, 'toast'>,
  previousUrl?: string
) => {
  try {
    // Delete previous file if it exists
    if (previousUrl) {
      const previousFileName = previousUrl.split('/').pop();
      if (previousFileName) {
        const { error: deleteError } = await supabase.storage
          .from('profile-pictures')
          .remove([previousFileName]);

        if (deleteError) {
          console.error('Error deleting previous file:', deleteError);
        }
      }
    }

    const fileExt = file.name.split('.').pop();
    const fileName = `${crypto.randomUUID()}.${fileExt}`;

    const { error: uploadError } = await supabase.storage
      .from('profile-pictures')
      .upload(fileName, file);

    if (uploadError) throw uploadError;

    const { data: { publicUrl } } = supabase.storage
      .from('profile-pictures')
      .getPublicUrl(fileName);

    return publicUrl;
  } catch (error) {
    console.error('Error uploading file:', error);
    toast.toast({
      title: "Error",
      description: "Failed to upload profile picture",
      variant: "destructive",
    });
    return null;
  }
};